// @ts-nocheck
import { useEffect } from 'react';
import { isFreeTrialURL } from 'src/lib/utils';

const useHotjar = () => {
  useEffect(() => {
    if (isFreeTrialURL()) {
      // Ensure `window` has our custom types
      interface HotjarWindow extends Window {
        hj?: (...args: any[]) => void;
        _hjSettings?: { hjid: number; hjsv: number };
      }

      const w = window as HotjarWindow;

      (function (h: HotjarWindow, o: Document, t: string, j: string) {
        h.hj =
          h.hj ||
          function (...args: any[]) {
            (h.hj!.q = h.hj!.q || []).push(args);
          };
        h._hjSettings = { hjid: 5363018, hjsv: 6 };

        const head = o.getElementsByTagName('head')[0];
        const script = o.createElement('script');
        script.async = true;
        script.src = `${t}${h._hjSettings.hjid}${j}${h._hjSettings.hjsv}`;
        head.appendChild(script);
      })(w, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }
  }, []);
};

export default useHotjar;
